import { render, staticRenderFns } from "./ListTiposFornecedor.vue?vue&type=template&id=287ac054"
import script from "./ListTiposFornecedor.vue?vue&type=script&lang=js"
export * from "./ListTiposFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ListTiposFornecedor.vue?vue&type=style&index=0&id=287ac054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports